import type { ChartConfig, Choice } from "../types";

type Args = {
  colorsByChoiceId: Record<string, string>;
  sortedChoices: Choice[];
};

export const createChartConfig = ({ colorsByChoiceId, sortedChoices }: Args): ChartConfig => {
  const config: ChartConfig = {};

  for (const choice of sortedChoices) {
    const color = colorsByChoiceId[choice.id];
    config[choice.id] = {
      label: choice.name,
      color: color,
    };
  }

  return config;
};
